/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import Theme from "../utils/Theme";

const StyledContainer = styled.div`
  cursor: ${props => (props.active ? "pointer" : "not-allowed")};
  background: ${props => (props.active ? Theme.TertiaryColor : "lightgrey")};
  padding: 10px 15px;
  display: inline-flex;
  flex-direction: row;
  color: white;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 1em;
  text-transform: capital;
  &:hover {
    opacity: ${props => (props.active ? "0.5" : "1")};
    text-decoration: ${props => (props.active ? "underline" : "none")};
  }
`;

class PaynowButton extends Component {
  onClicked = e => {
    const { onClicked } = this.props;

    e.stopPropagation();
    onClicked ? onClicked(e) : false;
  };

  render() {
    const { style, active } = this.props;

    return (
      <StyledContainer
        active={active}
        style={style}
        onClick={e => {
          this.onClicked(e);
        }}
      >
        <FormattedMessage
          id="cart.paynow.title"
          defaultMessage="Place Order"
          description="Pay Now Title"
        />
      </StyledContainer>
    );
  }
}

PaynowButton.propTypes = {
  onClicked: PropTypes.func.isRequired,
  active: PropTypes.bool,
  style: PropTypes.object
};

PaynowButton.defaultProps = {
  active: true
};

export default PaynowButton;



// WEBPACK FOOTER //
// ./src/components/PaynowButton.js